import { github, linkedin, instagram, gmail } from "../assets";

export const contactList = [
  {
    icon: github,
    tooltip: "Github",
    url: "https://github.com/omjain2001",
  },
  {
    icon: linkedin,
    tooltip: "Linkedin",
    url: "https://www.linkedin.com/in/omjain26",
  },
  {
    icon: instagram,
    tooltip: "Instagram",
    url: "https://www.instagram.com/om_jain2606/",
  },
];

export const contactListHomePage = [
  {
    icon: github,
    tooltip: "Github",
    url: "https://github.com/omjain2001",
  },
  {
    icon: linkedin,
    tooltip: "Linkedin",
    url: "https://www.linkedin.com/in/omjain26",
  },
  {
    icon: gmail,
    tooltip: "Gmail",
    url: "mailto:omjain2606@gmail.com",
  },
];
